import { render, staticRenderFns } from "./TopicCloud.vue?vue&type=template&id=2c34d3d8&"
import script from "./TopicCloud.vue?vue&type=script&lang=js&"
export * from "./TopicCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports